module.exports = __webpack_public_path__ + "static/media/Card_Stethoscope.8b00757d.svg";